import { TOKEN_TABLEAU, LOGIN_SUCCESS, CLEAR_PERSISTED_DATA, LOGOUT, SET_USER, GET_WEATHER, GET_BIRTHDAYS, GET_ALL_BIRTHDAYS, GET_USERS, GET_NOTIFICATIONS } from '../actions/types';

import { INITIAL_STATE } from '../states/states';

export default (state = INITIAL_STATE.AUTH, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return { ...state, isAuthenticated: action.payload };
    case SET_USER:
      return { ...state, userData: action.payload };
    case LOGOUT:
      return INITIAL_STATE.AUTH;
    case CLEAR_PERSISTED_DATA:
      return INITIAL_STATE.AUTH;
    case GET_ALL_BIRTHDAYS:
      return { ...state, allBirthDays: action.payload };
    case GET_BIRTHDAYS:
      return { ...state, birthDays: action.payload };
    case GET_WEATHER:
      return { ...state, weatherLocale: action.payload };
    case GET_USERS:
      return { ...state, users: action.payload };
    case GET_NOTIFICATIONS:
      return { ...state, notifications: action.payload };
    default:
      return state;
  }
};
